// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"c99cec76","403":"2808a930","551":"602f4f88","672":"5046bdb2","842":"02d6a883"}[chunkId] + ".chunk.js";
};